import { takeLatest,put,call} from 'redux-saga/effects'
import { createAccountSuccess,createAccountFaild } from '../actions/users'
import { baseUrl } from '../../utils/index';
import axios from "axios";
function getApi({values}){//   
    return  axios.post(`${baseUrl}/user/createAccount`,values);
}
const parseApiError = (data) => {
  if (!data) return { eng: "Request failed", amh: "ጥያቄ አልተሳካም" };
  if (data.msg?.eng || data.msg?.amh) return data.msg;
  if (Array.isArray(data.error) && data.error[0]?.msg) {
    const text = data.error[0].msg;
    return { eng: text, amh: text };
  }
  if (typeof data.msg === "string") return { eng: data.msg, amh: data.msg };
  return { eng: "Request failed", amh: "ጥያቄ አልተሳካም" };
};

function* createAcc({ payload: { values } }) {
  try {
    const newAccount = yield call(getApi, { values });
    const data = newAccount.data;
    if (data?.error === true || data?.error === "true") {
      yield put(createAccountFaild(parseApiError(data)));
      return;
    }
    if (data?.msg) {
      yield put(createAccountSuccess(data.msg));
      return;
    }
    yield put(
      createAccountFaild({
        eng: "Unexpected response from server.",
        amh: "ከሰርቨር ያልተጠበቀ መልስ ተመለሰ።",
      })
    );
  } catch (error) {
    yield put(
      createAccountFaild(parseApiError(error.response?.data || { msg: error.message }))
    );
  }
}
function* createAccount(){
    yield takeLatest('CREATE_ACCOUNT_REQUESTED',createAcc);
}
export default createAccount;